import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "../../../api/src/router";
export type { GetUserOutput } from "../../../api/src/types";
export type { GetPublicationsOutput } from "../../../api/src/types";
export type { GetAnnotationsOutput } from "../../../api/src/types";
export type { SearchAllOutput } from "../../../api/src/types";

export const trpc = createTRPCReact<AppRouter>({
  overrides: {
    useMutation: {
      async onSuccess(opts) {
        await opts.originalFn();
        await opts.queryClient.invalidateQueries();
      },
    },
  },
});
